<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ChannelIndex',

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>

<style lang="scss" scoped>

</style>